import { PopoverInteractionKind, TooltipProps } from "@blueprintjs/core";
import React, { ReactChild, ReactNode } from "react";

import { StyleableHexPopover } from "../../hex-components";

import {
  FeatureGateAndSalesContactProps,
  FeatureGateZeroState,
  FeatureGateZeroStateProps,
} from "./FeatureGateZeroState";

export type FeatureGateToolTipProps = Omit<
  TooltipProps,
  "hoverCloseDelay" | "interactionKind" | "content"
> & {
  // Our underlying component, Blueprint's popover, only renders the first child given.
  // So use `ReactChild` to make sure we don't accidentally provide more.
  readonly children?: ReactChild;
  buttonStyle?: boolean;
  titleOverride?: ReactNode;
  illustration?: ReactNode;
  icon?: ReactNode;
} & (
    | {
        action: string;
        descriptionOverride?: undefined;
      }
    | {
        action?: undefined;
        descriptionOverride: string;
      }
  );

export const FeatureGateToolTip: React.ComponentType<
  FeatureGateToolTipProps &
    FeatureGateAndSalesContactProps &
    FeatureGateZeroStateProps
> = React.memo(function FeatureGateToolTip({
  action,
  children,
  descriptionOverride,
  featureGate,
  icon,
  illustration,
  onInteraction,
  requiresSalesContact,
  titleOverride,
  ...props
}: FeatureGateToolTipProps &
  FeatureGateAndSalesContactProps &
  FeatureGateZeroStateProps) {
  return (
    <StyleableHexPopover
      content={
        <FeatureGateZeroState
          {...(typeof action === "string"
            ? {
                action,
                descriptionOverride: undefined,
              }
            : {
                action: undefined,
                descriptionOverride,
              })}
          icon={icon}
          illustration={illustration}
          isTooltip={true}
          titleOverride={titleOverride}
          {...(requiresSalesContact
            ? {
                requiresSalesContact: true,
                featureGate,
              }
            : {
                requiresSalesContact: false,
                featureGate,
              })}
        />
      }
      hoverCloseDelay={800}
      interactionKind={PopoverInteractionKind.HOVER}
      minimal={true}
      placement={props.placement ?? "bottom"}
      targetTagName="div"
      {...props}
    >
      {children}
    </StyleableHexPopover>
  );
});
